import React from 'react';
import { WeatherIcon } from 'assets/icons/WeatherIcon';
import { Text } from 'components/typography/Text';
import styles from './styles.module.scss';
import WeatherSlider from './components/WeatherSlider';

export const WeatherPreview = ({ weather, error }) => (
  <div>
    {!error ? (
      <WeatherSlider weather={weather} />
    ) : (
      <>
        <div className={styles.noWeatherData}>
          <WeatherIcon />
        </div>

        <Text
          center
          bold
          gray
          large
          intl="weatherDataNotFound"
        />
      </>
    )}
  </div>
);
